import { colorPalette } from '../../colorPalette';
export const tooltipStyle = {
    '& > div': {
        p: 0.5,
        fontWeight: 400,
        backgroundColor: colorPalette.gray900,
    },
};
